import Image from "next/image";
import { useState } from "react";
import { conditions, videoTag } from "helpers";
import { ConditionName } from "interfaces";
import IMAGES from "../../../../../images/importImages";
import { useAppSelector } from "redux-share";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const ControllbarTooltip = dynamic(() => import("../../mainComponent/footer/controllbar/controllbarTooltip"));

const PictureInPicture = () => {

    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params } }) => ({ videoElementSizeInfo, params }), shallowEqual);

    return (
        <div className="pl-relative pl-flex  pl-items-center">
            <Image onMouseOver={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(true)} onMouseLeave={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(false)} src={IMAGES.pictureInPicture} width={conditions(ConditionName.isMiniPlayer) ? 13 : 22} height={conditions(ConditionName.isMiniPlayer) ? 14 : 22} className="pl-flex pl-cursor-pointer" onClick={() => videoTag().requestPictureInPicture()} />
            {showTooltip && <ControllbarTooltip title="تصویر در تصویر (i)" className="!pl-right-[-48px]"/>}
        </div>
    )
}

export default PictureInPicture;